import { axiosCms } from 'Axios.js';
import { authToken } from '../utility';
import * as actionTypes from './actionTypes';

const fetchAppUsersStart = () => ({ type: actionTypes.FETCH_APP_USERS_START });
const fetchAppUsersEnd = appUsers => ({ type: actionTypes.FETCH_APP_USERS_END, appUsers });

const updateAppUsersStart = () => ({ type: actionTypes.UPDATE_APP_USERS_START });
const updateAppUsersEnd = message => ({ type: actionTypes.UPDATE_APP_USERS_END, message });

export const fetchAppUsers = option => {
  return dispatch => {
    dispatch(fetchAppUsersStart());
    const {  sort } = option;
    const sortKeys = Object.keys(sort);
    let url = '/contractors?';
    sortKeys.forEach((k, i) => {
      url += (i !== 0 ? '&' : '') + `order_by=${k} ${sort[k]}`;
    });

    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());
    return axiosCms
      .get(url)
      .then(resp => {
        const { data } = resp;
        dispatch(fetchAppUsersEnd(data.list));
        return data.list;
      })
      .catch(err => {
        return Promise.reject(err);
      });
  };
};

export const updateAppUsers = (id, status) => {
  return dispatch => {
    dispatch(updateAppUsersStart());

    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());
    return axiosCms
      .patch('/contractors/' + id + '/approve', { approved: status })
      .then(resp => {
        const { data } = resp;
        dispatch(updateAppUsersEnd(data.message));
        return data;
      })
      .catch(err => {
        return Promise.reject(err);
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/appUsers.js